import Repeater from '../../../components/repeater/Repeater';
import CardLocation from '../../../components/cards/card-location/CardLocation';
import { LocationContainer, StyledContentWrapper } from './Locations.style';
import React from 'react';
import SectionHeader from '../../../components/section-header/SectionHeader';

interface IProps {
  mainTitle: string;
  title: string;
  mainTitleFontSize?: number;
  titleFontSize?: number;
  mainTitleMobileFontSize?: number;
  titleMobileFontSize?: number;
  mainTitleFontWeight?: number;
  mainTitleMobileFontWeight?: number;
  titleFontWeight?: number;
  titleMobileFontFontWeight?: number;
  location: {
    address: string;
    image: any;
  }[];
}

const Locations: React.FC<{ data: IProps; isPrerenderRequest: boolean }> = ({
  data,
  isPrerenderRequest,
}: {
  data: IProps;
  isPrerenderRequest: boolean;
}) => {
  return (
    <StyledContentWrapper>
      {data?.mainTitle || data?.title ? (
        <SectionHeader
          subtitle={data?.mainTitle ?? ''}
          title={data?.title ?? ''}
          titleFontSize={data?.titleFontSize}
          mainTitleFontSize={data?.mainTitleFontSize}
          titleMobileFontSize={data?.titleMobileFontSize}
          mainTitleMobileFontSize={data?.mainTitleMobileFontSize}
          mainTitleFontWeight={data?.mainTitleFontWeight}
          mainTitleMobileFontWeight={data?.mainTitleMobileFontWeight}
          titleFontWeight={data?.titleFontWeight}
          titleMobileFontWeight={data?.titleMobileFontFontWeight}
        />
      ) : (
        <></>
      )}
      <LocationContainer>
        <Repeater
          data={data?.location}
          component={CardLocation}
          spacing={2}
          cols={{ xs: 12, sm: 6, lg: 3 }}
          props={{ isPrerenderRequest }}
        />
      </LocationContainer>
    </StyledContentWrapper>
  );
};

export default Locations;
